import React from 'react';
import {Spinner} from "react-bootstrap";

function Spiner(props) {
    return (
        <div className="d-flex position-absolute justify-content-center align-items-center" style={
            {
                height: '100vh',
                zIndex:'1000',
                margin:'0 auto',
                background:'#0908083d',
                left:0,
                right:0
            }
        }>
            <Spinner animation="border" variant="success" style={{
                width: '4em',
                height: '4em',
                marginBottom: '20px'
            }}/>
        </div>
    );
}

export default Spiner;
